import React from 'react';
import { connect } from 'react-redux';
import {Helmet} from 'react-helmet';
import { startLogin } from '../actions/auth'; 
// import { FooterSection } from './FooterSection'; 
import Footer from "../components/common/Footer";
import  PicMuiTabs from './PicMuiTabs'; 
import  getAppConfigParm  from '../config/AppConfig';
import  VisibilityWrapper   from "../components/common/VisibilityWrapper";
import { displayAd } from './advertisements/helpers/displayAd';
// import { GoogleAdInit } from './advertisement/GoogleAdInit';


// PicMuiTabsPage is the top level component. It renders the PageHeader (as part of Private Route), 
// top ad leaderboard, MuiTab selection, and ad-leaderboard (bottom of page). This page is self 
// contained. That is, the onSubmit action is called from the local onsubmit method instead of 
// parent onsubmit method. This is similar to what was done on the SignUp Form.
// This component passes its onSubmit method down to the LoginForm child component.
// It delegates the data entry and form data validation to the form itself. Once the
// form has validated the data, it will pass the form data up to this component by calling
// the onSubmit method passed down as a function prop. That form data will used to dispatch
// the startLogin action. The startLogin action will log in the user, and update redux store 
// with user firstname, email, token, and isAuthenticated flag. When action successfully completes, 
// the user will be routed to the '/dashboard'. If login fails, the auth.error property 
// will be updated on the redux store and component will re-render with error message on top of form.
export class PicEventMgtPage extends React.Component { 

    onSubmit = (formData = {}) => {
        this.props.startLogin(formData);
    };

    /* This function adjusts the view port height based on whether Ads are displayed or not. The function
       returns an object with the height property */
    setViewPortHeight = (condition) => {
       return condition ? { minHeight: '93vh' } :  { minHeight: '70vh' }
    }

     
    // Render PicMuiTabs and pass onSubmit function above, as function prop, to LoginForm. This function 
    // prop will be called when user enters email and password and clicks onSumbit on form itself.
    render() {

        /* Get the showAd directive from the AppConfig. This will drive styles on the page */
        let showAd = getAppConfigParm("showAd");
        let showSkyScraper = false;

        return (
            <div> 
               <Helmet>
                   <title>Manage Event</title>
                   <meta name="description" content="Manage Event" />
               </Helmet>
               <VisibilityWrapper show={showAd} contentType="advertisement" >
                    <div className="rc-flex-container-center-hv"  style={{borderTop: '1px solid #95A5A6'}}>
                    {displayAd("web-leader-board", "desktop", {marginLeft: '0rem', marginTop: '1.3rem', marginBottom: '1.3rem'})}
                    {displayAd("mobile-leader-board", "mobile", {marginTop: '1rem', marginBottom: '1rem'})}
                    {displayAd("web-leader-board", "tablet", {marginTop: '1.3rem', marginBottom: '1.3rem'})}
                 </div>
               </VisibilityWrapper>  
               <div className="app-container">    
                   <div className="pic-event-mgt-container"> 
                        <PicMuiTabs value={this.props.match.params.value} />
                        <VisibilityWrapper show={showSkyScraper} contentType="advertisement" >
                            {displayAd("skyscraper", "desktop", {marginLeft: '3rem', marginTop: '4.2rem'})}
                        </VisibilityWrapper>  
                   </div>
               </div>
               {/*<VisibilityWrapper show={showAd} contentType="advertisement" >
                <div className="rc-flex-container-center-hv" style={{borderTop: '1px solid #BDC3C7'}}> 
                    {displayAd("web-leader-board", "desktop", {marginLeft: '0rem', marginTop: '1.3rem', marginBottom: '1.3rem'})}
                    {displayAd("", "mobile", {marginTop: '1rem', marginBottom: '1rem'})}
                    {displayAd("web-leader-board", "tablet", {marginTop: '1.5rem', marginBottom: '1.3rem'})}
                </div> 
                </VisibilityWrapper> */}
               <Footer />            
            </div>

        );
    };
};


// When using mapDispatchToProps you invoke function in your component as follows:
// this.props.startSignup(signupData) and not like this: this.props.dispatch(startSignup(signupData))
const mapDispatchToProps = (dispatch) => ({
    startLogin: (formData) => dispatch(startLogin(formData)),
})

const mapStateToProps = (state) => {
    return {
        auth: state.auth
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PicEventMgtPage);


/*
 <h3 className="ad-web-med-rectangle">-- Add Section Medium Rectangle</h3>
                            <h3 className="ad-web-med-rectangle">-- Add Section Medium Rectangle</h3>
*/


// WEBPACK FOOTER //
// ./src/components/PicEventMgtPage.js